// recursively checks if a componentized page has a product on the page
const pageHasProduct = component => {
  if (!component) return false
  if (component.primaryProduct) return true
  if (component.targetProduct) return true
  if (component.targetProductOverride) return true
  if (component.productOverride) return true

  const type = component.internal ? component.internal.type : ""
  switch (type) {
    case "ContentfulComponentizedPage":
      return (
        (component.bodyComponents && component.bodyComponents.some(pageHasProduct)) ||
          pageHasProduct(component.announcementBar)
      )

    case "ContentfulTextWithMedia":
      return pageHasProduct(component.button)

    case "ContentfulFeaturedProductLayout":
      return pageHasProduct(component.form) || pageHasProduct(component.productDescription)

    case "ContentfulPageNavigationBar":
    case "ContentfulAnnouncementBar":
      return pageHasProduct(component.ctaButton)

    case "ContentfulHero":
      return pageHasProduct(component.button)

    default:
      return false
  }
}

module.exports = pageHasProduct
